import { Web3Address } from 'multirpc-sdk';

import { AccountPermission } from 'modules/permissions/constants';
import { IAccount } from 'modules/common/types';
import { checkAccountPermission } from 'modules/permissions/utils/checkAccountPermission';

export interface SortGroupAccountsParams {
  selectedTeamAccountAddress: Web3Address | undefined;
  teamAccounts: IAccount[];
}

export const sortTeamAccounts = ({
  selectedTeamAccountAddress,
  teamAccounts,
}: SortGroupAccountsParams) => {
  return [...teamAccounts].sort((accountA, accountB) => {
    if (accountA.address === selectedTeamAccountAddress) {
      return -1;
    }

    if (accountB.address === selectedTeamAccountAddress) {
      return 1;
    }

    const permission = AccountPermission.TeamManagement;

    if (checkAccountPermission({ permission, role: accountA.role })) {
      return -1;
    }

    if (checkAccountPermission({ permission, role: accountB.role })) {
      return 1;
    }

    return 0;
  });
};
